import React, { useEffect, useState } from "react";
import { styled, useTheme, alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useLocation, useHistory } from "react-router-dom";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";

import {
  FaFileAlt,
  FaRobot,
  FaSignInAlt,
  FaCloudUploadAlt,
  FaPlus,
  FaMinus
} from "react-icons/fa";
import Topnavbar from "./Topnavbar";
import profile from "../../assets/img/user.png";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import { useMsal } from "@azure/msal-react";
import Getusers from "../auth/Getusers";
import axios from "axios";
// import { useOktaAuth } from "@okta/okta-react";
import { loginRequest1 } from "../auth/authConfig";

const drawerWidth = 300;


const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  // backgroundImage: `linear-gradient(rgba(0,0,160,0.5), rgba(47, 46, 53,0.9)),url(${bgimg})`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  background: "#000",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  "&& .Mui-selected": {
    outline: "0px",
    border: "0px",
    cursor: "pointer",
    userSelect: "none",
    verticalAlign: "middle",
    appearance: "none",
    display: "flex",
    flexGrow: "1",
    justifyContent: "flex-start",
    alignItems: "center",
    textDecoration: "none",
    boxsizing: "border-box",
    textAlign: "left",
    transition: "background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    position: "relative",
    textTransform: "capitalize",
    color: "rgb(32, 101, 209);",
    // borderRadius: "8px !important",
    backgroundcColor: "#0000a0 !important",
    fontWeight: "700 !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "20px !important",
  },
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  backgroundColor: "#000",
  color: "white",
  overflowX: "hidden",
  borderRight: "1px dotted rgba(86,88,105, 1) !important",
  padding: "0px",

  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 20px)`,
  },
  "&& .Mui-selected": {
    // borderRadius: "8px !important",
  },
  "&& .logoutLayout": {
    // add any additional styles for logoutLayout class here
    left: "8px !important",
  },
});

const openbox = (theme) => ({
  left: "286px !important",
});

const closebox = (theme) => ({
  left: "72px !important",
});

const listTogglebox = (theme) => ({
  padding: "0 !important",
  paddingTop: "2rem !important",
  padding: "1rem .5rem 0rem !important",
  borderRadius: "20px",
});

const listTogglebox1 = (theme) => ({
  display: "none !important",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  padding: theme.spacing(4, 2.6),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "noWrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
    "& .navButtonToggle": openbox(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
    "& .navButtonToggle": closebox(theme),
    "& .listToggle": listTogglebox(theme),
    "& .listToggle1": listTogglebox1(theme),
  }),
}));

const userList = [
  {
    username: "nabasundar.rout@effem.com"
  },
  {
    username: "harshk@aaysinsight.com"
  },
  {
    username: "dwarika.patro@aaysinsight.com"
  },
  {
    username: "himanisingh@aaysinsight.com"
  },
  {
    username: "dipr@aaysinsight.com"
  },
  {
    username: "nitingupta@aaysinsight.com"
  },
  {
    username: "sanchitkumar@aaysinsight.com"
  },
  {
    username: "sumit.shekhar@aaysinsight.com"
  },
  {
    username: "sanchitkumar@aaysinsight.com"
  }
];

const SideNavbar = ({ isNewchatbtn, newChatStart, isfatching, filteredToday, messageClick, handleDeletePopup, filteredyesteday, filteredLastweek, filteredLastMonth, LoggedinUser }) => {
  const { accounts, instance } = useMsal();
  const account = accounts?.[0];
  const [open, setOpen] = useState(false);
  const [openDialog, setopenDialog] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const history = useHistory();
  const [profileImage, setProfileImage] = useState(null)
  const [showHistory, setShowHistory] = useState(true); // 👈 state for toggle
  const [currentSessionId, setCurrentSessionId] = useState(null);


  const getProfilePhoto = async () => {
    try {
      // Ensure you acquire a token for the signed-in user
      const response = await instance.acquireTokenSilent({
        ...loginRequest1,
        account: accounts[0], // Use the first account from the authenticated accounts
      });

      const token = response.accessToken;

      console.log(token)

      // Fetch the profile photo
      const photoResponse = await axios.get(
        "https://graph.microsoft.com/v1.0/me/photo/$value",
        {
          headers: {
            Authorization: `Bearer ${token}`, // Pass the token in the Authorization header
          },
          responseType: "arraybuffer", // To receive the image as binary data
        }
      );

      const blob = new Blob([photoResponse.data], { type: "image/jpeg" });
      const imageUrl = URL.createObjectURL(blob);
      setProfileImage(imageUrl);
    } catch (err) {
      console.error("Error fetching profile photo", err);
    }
  };

  useEffect(() => {
    getProfilePhoto();
  }, []);


  const { pathname } = useLocation();

  const MenuItems = [
    {
      menu: "Chat",
      route: "/",
      icon: <FaRobot className="colorCss" fontSize={24} />,
    },
    {
      menu: "Generate Summary",
      route: "/Generate-Summary",
      icon: <FaFileAlt className="colorCss" fontSize={24} />,
    },
    {
      menu: "Upload",
      route: "/upload",
      icon: <FaCloudUploadAlt className="colorCss" fontSize={24} />,
    }

  ];


  useEffect(() => {
    // Save the profile image to localStorage whenever it changes
    localStorage.setItem("profileImage", profileImage);
  }, [profileImage]);

  const handleImageChange = (event) => {
    const selectedImage = event.target.files[0];

    if (selectedImage) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setProfileImage(reader.result);
      };

      reader.readAsDataURL(selectedImage);
    }
  };

  const logout = async () => {
    await instance.logoutRedirect({
      postLogoutRedirectUri: "/", // Redirect here after logout
    });
  };

  const historyList = []


  return (
    <>
      <Box sx={{ display: "flex" }}>
        <Topnavbar open={open} src={profileImage || profile} />

        <Drawer className="sidenavBarstyle" variant="permanent" open={open}>
          <IconButton
            className="navButtonToggle bgColorNew borderColorNew"
            onClick={() => {
              setOpen(!open);
            }}
          >
            {open === false ? (
              <ChevronRightIcon className="colorCss" />
            ) : (
              <ChevronLeftIcon className="colorCss" />
            )}
          </IconButton>

          {open ? (
            <div style={{ color: "white", justifyContent: "space-between" }} className="flex p-3">
              <span className="listToggle1" onClick={() => setOpen(!open)}> <MenuOpenIcon /></span>
              <span style={{ cursor: "pointer" }} onClick={newChatStart}> <AppRegistrationIcon /></span>
            </div>
          ) : (
            <div style={{ color: "white", justifyContent: "center" }} className="p-3">
              <span style={{ cursor: "pointer" }} onClick={newChatStart} className="grid item-center justify-center pointer"> <AppRegistrationIcon sx={{ fontSize: "28px" }} /></span>
            </div>
          )}





          <List
            className="listToggle"
            style={{
              padding: "1.3rem",
              display: "grid",
              gridGap: "1rem",
              paddingTop: "2rem",
            }}
          >


            {MenuItems.map((menuItem, index) => {
              if (
                (menuItem.menu === "Register" ||
                  menuItem.menu === "Feedback") &&
                !userList.some((user) => user.username === userInfo?.email)
              ) {
                return null; // Do not render the menu item
              }

              return (
                // <a href={`${}`}>
                <ListItem
                  onClick={() => history.push(menuItem.route)}
                  key={index}
                  style={{ color: "white" }}
                  className="itemsmenulist colorCss"
                  selected={menuItem.route === pathname}
                  disablePadding
                  sx={{ display: "block" }}
                  title={menuItem.menu}
                >
                  <ListItemButton
                    sx={{
                      minHeight: 53,
                      justifyContent: open ? "initial" : "center",
                      px: 2.5,
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 0,
                        mr: open ? 3 : "auto",
                        justifyContent: "center",
                      }}
                      // className="colorCss"
                    >
                      {menuItem.icon}
                    </ListItemIcon>
                    <ListItemText
                      className="listToggle1"
                      primary={menuItem.menu}
                      sx={{ opacity: open ? 1 : 0 }}
                    />
                  </ListItemButton>
                </ListItem>
                // </a>
              );
            })}


            {filteredToday && filteredToday.length > 0 && (
              <>

                <span style={{ marginTop: "1rem", fontWeight: "600", justifyContent: "space-between", alignItems: "center", fontSize: "14px", alignContent: "center" }} className="listToggle1 flex">
                  <span> Recent History</span>
                  <span
                    onClick={() => setShowHistory((prev) => !prev)} // 👈 toggle state

                  >{showHistory ? <FaMinus /> : <FaPlus />}</span>


                </span>
                {
                  showHistory && (
                    <div id="historydata" className="grid gap-2">
                      {filteredToday && filteredToday.map((item, idx) => (
                        <ListItem
                          key={idx}
                          // onClick={() => handleHistoryClick(item.session_id)}
                          className={`rounded listToggle1 border ${
                            currentSessionId === item.session_id ? "active" : ""
                          }`} // 👈 add active class
                          disablePadding
                          sx={{ display: "block" }}
                          title={item.first_question}
                        >
                          <ListItemButton
                            sx={{
                              minHeight: 40,
                              justifyContent: open ? "initial" : "center",
                              px: 2,
                            }}
                            
                            >


                            <ListItemText
                              className="listToggle1 text-white"
                              primary={
                                open
                                  ? item.first_question.length > 25
                                    ? item.first_question.slice(0, 25) + "..."
                                    : item.first_question
                                  : "" // hide text if drawer closed
                              }
                              onClick={() => {
                                messageClick(item.session_id)
                                setCurrentSessionId(item.session_id);
                              }}
                              sx={{ opacity: open ? 1 : 0 }}  // 👈 Added here
                            />
                          </ListItemButton>
                        </ListItem>
                      ))}
                    </div>
                  )
                }

              </>
            )}


            <div
              className="logoutLayout"

            >


              <ListItem
                className="itemsmenulist itemsmenulist2  LogoutBTn"
                title="Logout"

                disablePadding
                sx={{ display: "block" }}
                onClick={() => {
                  setopenDialog(!openDialog);
                }}
              >
                <ListItemButton
                  sx={{
                    minHeight: 53,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      mr: open ? 3 : "auto",
                      justifyContent: "center",
                    }}
                  >
                    <FaSignInAlt className="colorCss" fontSize={20} />
                  </ListItemIcon>
                  <ListItemText
                    className="listToggle1 colorCss"
                    primary="Logout"
                    sx={{ opacity: open ? 1 : 0 }}
                  // onClick={logout}
                  />
                </ListItemButton>
              </ListItem>
            </div>
          </List>
        </Drawer>

        <Dialog
          open={openDialog}
          onClose={() => {
            setopenDialog(!openDialog);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          id="logoutPopup"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are you sure you want to logout ?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Please confirm your decision.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                setopenDialog(!openDialog);
              }}
            >
              No
            </Button>
            <Button onClick={logout}>Yes</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  );
};

export default SideNavbar;
